import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatSliderModule } from "@angular/material/slider";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { MatDialogModule } from "@angular/material/dialog";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ButtonComponent } from "./button/button.component";
import { MatIconModule } from "@angular/material/icon";
import { MatSelectModule } from "@angular/material/select";
import { SharedModule } from "src/app/core/utils/shared.module";
import { SnackBarComponent } from "./snack-bar/snack-bar.component";
import { LoaderComponent } from "./loader/loader.component";
import { GenerateQrDialogComponent } from "./generate-qr-dialog/generate-qr-dialog.component";
import { NgxQRCodeModule } from "@techiediaries/ngx-qrcode";
import { DialogConfirmComponent } from "./dialog-confirm/dialog-confirm.component";
import { DialogPlantsComponent } from './dialog-plants/dialog-plants.component';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatTableModule } from "@angular/material/table";

@NgModule({
  declarations: [
    ButtonComponent,
    SnackBarComponent,
    LoaderComponent,
    GenerateQrDialogComponent,
    DialogConfirmComponent,
    DialogPlantsComponent,
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatSliderModule,
    MatButtonModule,
    MatInputModule,
    FormsModule,
    MatIconModule,
    MatSelectModule,
    SharedModule,
    NgxQRCodeModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatTableModule
  ],
  exports: [
    ButtonComponent,
    SnackBarComponent,
    LoaderComponent,
  ],
})
export class SharedComponentsModule {}
